import React, { useState, useRef, useEffect } from "react";
import { View, Text, TextInput, StyleSheet, TouchableOpacity } from "react-native";
import { useTranslation } from 'react-i18next';
import PinInputComponent from "../../../common/steps/PinInputComponent";
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";
import Colors from "../../../../../constants/colors";
import { ComponentStyles } from "../../../../../constants/componentStyles";

type EnterPinStepProps = {
  attemptsLeft?: number;
  locked?: boolean;
  resetSignal?: number;
};

export default function EnterPinStep({ attemptsLeft, locked, resetSignal = 0 }: EnterPinStepProps) {
  const { t } = useTranslation();
  const [pin, setPin] = useState(["", "", "", ""]);
  const inputs = useRef<(TextInput | null)[]>([]);
  const setConsumerPin = useSessionStore((s: any) => s.setConsumerPin);
  const isNewConsumer = useSessionStore((s: SessionState) => (s as any).isNewConsumer);

  // Watch for reset signal to clear PIN inputs
  useEffect(() => {
    setPin(["", "", "", ""]);
  }, [resetSignal]);

  const handleChange = (text: string, index: number) => {
    if (/^\d*$/.test(text)) {
      const newPin = [...pin];
      newPin[index] = text;
      setPin(newPin);
      try { setConsumerPin?.(newPin.join("")); } catch {}
      // Move to next box automatically
      if (text && index < 3) {
        inputs.current[index + 1]?.focus();
      }
      // Backspace handling
      if (!text && index > 0) {
        inputs.current[index - 1]?.focus();
      }
    }
  };

  return (
    <View style={styles.container}>
      <PinInputComponent
          title={t("PIN_INPUT_TITLE")}
          subTitle={t("PIN_INPUT_SUBTITLE")}
          pin={pin}
          handleChange={handleChange}
          inputsRef={inputs}
          attemptsLeft={attemptsLeft}
          locked={locked}
          // pinError={t("PIN_INPUT_ERROR")}
        />

      {/* Attempts left / account locked */}
      {/* {isNewConsumer ?
        pin.join("").length > 0 && pin.join("").length < 4 && (
          <Text style={styles.error}>{t("PIN_INPUT_ERROR")}</Text>
        ) : !locked ? (
          <Text style={styles.attempts}>
            {attemptsLeft} {attemptsLeft === 1 ? "attempt" : "attempts"} remaining
          </Text>
        ) : (
          <Text style={styles.locked}>{t("ACCOUNT_LOCKED")}</Text>
        )} */}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    justifyContent: "flex-start",
    marginTop: 16,
    marginBottom: 40,
  },
  title: {
    fontSize: 22,
    fontWeight: "700",
    marginBottom: 6,
    color: "#111827",
  },
  subtitle: {
    fontSize: 14,
    color: "#6B7280",
    marginBottom: 20,
  },
  pinContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  pinInput: {
    width: 60,
    height: 60,
    borderWidth: 1,
    borderColor: "#D1D5DB",
    borderRadius: 12,
    textAlign: "center",
    fontSize: 22,
    fontWeight: "600",
    backgroundColor: "#F9FAFB",
    marginRight: 24
  },
  error: {
    color: "red",
    fontSize: 12,
    marginTop: 8,
  },
  attempts: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: '400',
    lineHeight: 23,
    color: Colors.subTitleColor,
    marginBottom: 20
  },
  locked: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: '400',
    lineHeight: 23,
    color: Colors.errorRedColor,
    marginBottom: 20
  },
});
